import toast from 'react-hot-toast';
import { useMutation, useQueryClient } from 'react-query';

import {
  GROUP_SUBSCRIPTION_KEY,
  createTeamMembersSubscriptions,
} from '../utils/backend-api/groupSubscription';
import { TeamResponse } from '../utils/backend-api/teams';

export default function useCreateTeamMembersSubscriptions() {
  const queryClient = useQueryClient();
  const { mutate, mutateAsync, isLoading } = useMutation(
    (values: string[]) => createTeamMembersSubscriptions(values),
    {
      onSuccess: (data: TeamResponse) => {
        if (data.success) {
          toast.success('Team members were added.');
          queryClient.invalidateQueries([GROUP_SUBSCRIPTION_KEY, 'team']);
        }
      },
      onError: (e) => {
        console.error(e);
        toast.error('Team members were not added, please try again.');
      },
    }
  );

  return {
    addTeamMembers: mutate,
    addTeamMembersAsync: mutateAsync,
    isAddTeamMembersLoading: isLoading,
  };
}
